import { Link, Outlet, useLocation } from 'react-router-dom';
import { RadarProductTabs } from '../components/RadarProductTabs';

export function AppLayout() {
  const location = useLocation();
  const showRadarTabs = location.pathname.startsWith('/radar/');
  const active = (prefix: string) => prefix === '/' ? location.pathname === '/' || location.pathname === '/workspace' : location.pathname.startsWith(prefix);

  return (
    <div className="site-shell">
      <header className="site-header">
        <div className="content-width header-inner">
          <Link className="brand" to="/" aria-label="비즈니스 레이더 통합 홈">
            비즈니스 레이더
          </Link>
          <nav className="main-nav" aria-label="주요 메뉴">
            <Link className={active('/') ? 'main-nav-active' : ''} aria-current={active('/') ? 'page' : undefined} to="/">홈</Link>
            <Link className={active('/radar/') ? 'main-nav-active' : ''} aria-current={active('/radar/') ? 'page' : undefined} to="/radar/bids">Radar</Link>
            <Link className={active('/inbox') ? 'main-nav-active' : ''} aria-current={active('/inbox') ? 'page' : undefined} to="/inbox">검토 큐</Link>
            <Link className={active('/tools/') || active('/calculators') ? 'main-nav-active' : ''} aria-current={active('/tools/') || active('/calculators') ? 'page' : undefined} to="/tools/profitability">업무도구</Link>
          </nav>
        </div>
      </header>

      <main className="content-width site-main">
        {showRadarTabs ? <RadarProductTabs /> : null}
        <Outlet />
      </main>

      <footer className="site-footer">
        <div className="content-width">
          <p>공공정보는 원문을 최종 기준으로 확인하세요. 상권 경쟁지표는 공개 원천값을 바탕으로 한 탐색용 휴리스틱이며 수익을 보장하지 않습니다. 계산 결과는 참고용입니다.</p>
        </div>
      </footer>
    </div>
  );
}
